module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/f24ef0e4d71d4580436281c036ec1b5a.png";